import axios from 'axios'
import {apiDomain} from '../../config'

let axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
	    'token': localStorage.getItem('access_token')
	}
}

export default {
	addHaulsFolder (foldersHauls) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/hauls/folder/', foldersHauls, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
									data = response.data
									resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	test () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/hauls/test/',  { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
									data = response.data
									resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	getAll (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/hauls/', filter_by, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	getUnloadLocation (driver_id) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/hauls/unload/locations/'+driver_id+'/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
									data = response.data
									resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	getLoadLocation (energy_company_id,driver_id) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/hauls/load/locations/'+energy_company_id+'/'+driver_id+'/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
									data = response.data
									resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	save ( saveData ) {
		// alert(JSON.stringify(saveData))
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/haul/create/', saveData, { headers: {
				'Content-Type': 'application/json',
				'mobile':false,
				'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBy (haulId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/haul/' + haulId+'/', { headers: {
				'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
						var data = ''
						// alert(JSON.stringify(response.data.update_data))
						data = response.data.haul
						data = {
							'haul'			:	response.data.haul,
							'update_data'	:	response.data.update_data,
							'folders'		:	response.data.folders,
							'folder_haul'	:	response.data.folder_haul,
							'messages'		:	response.data.messages,
							'message'		:	response.data.message,
							'role'			:	response.data.role,
							'status'		:	response.data.status
						}
						resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update ( haulUpdate , id) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul/update/' + id+'/', haulUpdate, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	saveSelectedColumns ( selectColumns ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul/select_columns/', selectColumns, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete ( id ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/haul/delete/' + id+'/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					console.log('here')
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	remove ( haul_id, folder_id ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/remove/hauls/folder/' + haul_id+'/'+folder_id+'/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					console.log('here')
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restore ( id ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/haul/restore/' + id+'/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	saveFilters ( id, filters ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul/filters/' + id +'/', filters, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getFilters (id) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/hauls/filters_start/'+ id +'/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.filters_start, response.data.filters_start1, response.data.select_columns]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},	
	savePersonalTime ( id, personaltime ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul/personal_time/' + id +'/', personaltime, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message, response.data.data]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	sendFTP ( filter_ftp ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul/send_ftp/', filter_ftp, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getByv2 (haulId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/haul_detail/' + haulId+'/', { headers: {
				'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
						var data = ''
						// alert(JSON.stringify(response.data.update_data))
						data = response.data.haul
						data = {
							'haul'			:	response.data.haul,
							'status'		:	response.data.status
						}
						resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getByv22 (haulId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/haul_attributes/' + haulId+'/', { headers: {
				'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
						var data = ''
						// alert(JSON.stringify(response.data.update_data))
						data = response.data.haul
						data = {
							'haul'			:	response.data.haul,
							'folders'		:	response.data.folders,
							'folder_haul'	:	response.data.folder_haul,
							'messages'		:	response.data.messages,
							'message'		:	response.data.message,
							'role'			:	response.data.role,
							'status'	    :	response.data.status,
							'hazards'       : 	response.data.hazards,
							'controls'      : 	response.data.controls,

						}
						resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	get_trucking_companies (TruckingCompanyId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/haul_edit_data/' + TruckingCompanyId +'/', { headers: {
				'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
						var data = ''
						// alert(JSON.stringify(response.data.update_data))
						data = response.data.trucking_companies
						data = {
							'trucking_companies'	:	response.data.trucking_companies,
							'status'				:	response.data.status
						}
						resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	get_folders_by (EnergyCompanyId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/user_folders/' + EnergyCompanyId +'/', { headers: {
				'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
						var data = ''
						// alert(JSON.stringify(response.data.update_data))
						data = response.data.folders
						data = {
							'folders'	:	response.data.folders,
							'status'	:	response.data.status
						}
						resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAll1 () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/hauls_filter_content/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	get_trucking_hauls () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/haul_create_data/', { headers: {
				'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
						var data 	= ''
						data 		= response.data
						resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	export_to_csv (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/export_to_csv/', filter_by, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	HaulsApproved (HaulsApprovedIds) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/hauls_approved/', HaulsApprovedIds, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	HaulsIgnored (HaulsApprovedIds) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/hauls_ignored/', HaulsApprovedIds, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	get_duplicated_hauls (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/duplicated_hauls/', filter_by,{ headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	get_discrepancy_report (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/discrepancy_report/', filter_by,{ headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	update_values ( haulAdjust , id) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul/update_values/' + id+'/', haulAdjust, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	get_request_hauls (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/request_hauls/', filter_by,{ headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	save_request ( saveData ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/haul_request/create/', saveData, { headers: {
				'Content-Type': 'application/json',
				'mobile':false,
				'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update_request ( haulAdjust , id) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul/update_request/' + id+'/', haulAdjust, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	get_number_r () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/request_number/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	invoiced_cost_update ( haulUpdate , id) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/invoiced_cost/update/' + id+'/', haulUpdate, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
}



// WEBPACK FOOTER //
// ./src/views/hauls/haul_service.js